import { Rv } from '../../components'

export function AboutSection() {
  const specs = [
    ['Location', 'Clayton, VIC, Australia'],
    ['Tooling',  'Jira · Postman · BrowserStack'],
    ['Testing',  'JMeter · REST Assured · Appium'],
    ['Languages','English · Hindi · Gujarati'],
  ]
  const cards = [
    ['Quality Strategy',       'Hybrid manual + automated testing strategies, risk-based planning, and Agile/Scrum delivery — built for SDLC and STLC end to end.'],
    ['Automation Engineering', 'Selenium-Java frameworks built on OOP principles, with Appium for cross-platform Android coverage and TDD practices.'],
    ['Performance & APIs',     'JMeter performance testing validated for 10,000+ concurrent users; REST Assured, Postman & GraphQL for backend API and PostgreSQL data integrity.'],
  ]
  return (
    <section id="about" className="sec">
      <div className="wrap">
        <Rv className="sh"><div className="slb">About</div><h2 className="st">Built for Quality,<br/>Wired for Automation</h2><div className="gbar"/></Rv>
        <div className="ag">
          <Rv>
            <p className="ad">Results-driven IT professional with 2+ years of hands-on experience in QA automation and software testing across real-world client projects. Skilled in building Selenium-Java frameworks, executing API and performance testing, and delivering high-quality software in Agile environments.</p>
            <p className="ad" style={{ marginTop: '.9rem' }}>Currently pursuing a Master of IT (AI & Quantum Computing) at Monash University, Clayton — seeking a Software Developer, QA Engineer, or IT Graduate role to keep building reliable, scalable systems.</p>
            <div className="spg">
              {specs.map(([k, v]) => <div key={k} className="sp"><div className="spk">{k}</div><div className="spv">{v}</div></div>)}
            </div>
          </Rv>
          <Rv delay={0.18} className="acds">
            {cards.map(([h, p]) => <div key={h} className="gls acd"><h3>{h}</h3><p>{p}</p></div>)}
          </Rv>
        </div>
      </div>
    </section>
  )
}
